import React from "react";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
export const StyleBlock = (props) => (React.createElement("div", { className: useUtilityStyles(props?.styleOptions).utilities }, props?.children));
